import React, { useState, Children, cloneElement } from "react";
import cn from "classnames";
import Paper from "@material-ui/core/Paper";
import MUITabs from "@material-ui/core/Tabs";
import MUITab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import styles from "./styles/tabs.css.js";
import withStyles from "components/with-styles";
import { isMobileOnly } from "react-device-detect";

const Tabs = ({ children, onChangeTab, className, classes, selectedTab }) => {
  const [selected, setSelected] = useState(selectedTab || 0);

  const handleChange = (event, newValue) => {
    setSelected(newValue);
    onChangeTab && onChangeTab(newValue);
  };

  return (
    <Paper className={cn(className, classes.tabs)} square>
      <MUITabs
        value={selected}
        indicatorColor="secondary"
        textColor="primary"
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        orientation={isMobileOnly ? "vertical" : "horizontal"}
      >
        {Children.toArray(children)
          .filter(child => child != null)
          .map((child, index) => {
            const { label, disabled } = child.props;
            return (
              <MUITab
                key={index}
                value={index}
                label={label}
                disabled={disabled}
                className={cn(className, classes.tab)}
              />
            );
          })}
      </MUITabs>
      {Children.toArray(children)
        .filter(child => child != null)
        .map((child, index) => cloneElement(child, { ...child.props, index, selectedTab: selected }))}
    </Paper>
  );
};

Tabs.propTypes = {
  /**
   * Clase adicional del componente
   **/
  className: PropTypes.string,
  /**
   * Callback que se llama al cambiar de Tab
   **/
  onChangeTab: PropTypes.func,
  /**
   * Índice de la pestaña seleccionada
   **/
  selectedTab: PropTypes.number,
};

export default withStyles(styles)(Tabs);
